(function () {
  'use strict';

  var SELECTORS = {
    wrapper: '.slideshow-wrapper',
    carousel: '.slideshow',
    next: '[data-hero-slider-next]',
    previous: '[data-hero-slider-previous]'
  };

  /*
   * Find the Flickity instance used by Impulse.
   *
   * Flickity.data(element) returns the existing instance
   * instead of creating another slideshow.
   */
  function getFlickityInstance(wrapper) {
    if (typeof Flickity === 'undefined') {
      return null;
    }

    var carousel = wrapper.querySelector(SELECTORS.carousel);

    if (!carousel) {
      carousel = wrapper.querySelector('.flickity-enabled');
    }

    if (!carousel) {
      return null;
    }

    return Flickity.data(carousel) || null;
  }

  /*
   * Connect one Impulse slideshow to our custom buttons.
   */
  function setupHeroNavigation(wrapper) {
    if (!wrapper) {
      return;
    }

    /*
     * Prevent duplicate initialization.
     */
    if (wrapper.dataset.customHeroNavigation === 'true') {
      return;
    }

    var nextButton = wrapper.querySelector(SELECTORS.next);
    var previousButton = wrapper.querySelector(SELECTORS.previous);

    if (!nextButton || !previousButton) {
      return;
    }

    var flkty = getFlickityInstance(wrapper);

    /*
     * Flickity may not have initialized yet.
     * The retry allows Impulse's normal initialization
     * to finish before we connect the controls.
     */
    if (!flkty) {
      return;
    }

    wrapper.dataset.customHeroNavigation = 'true';

    /*
     * NEXT
     */
    nextButton.addEventListener('click', function (event) {
      event.preventDefault();

      var instance = getFlickityInstance(wrapper);

      if (instance) {
        instance.next();
      }
    });

    /*
     * PREVIOUS
     */
    previousButton.addEventListener('click', function (event) {
      event.preventDefault();

      var instance = getFlickityInstance(wrapper);

      if (instance) {
        instance.previous();
      }
    });
  }

  /*
   * Try to initialize all hero sliders.
   */
  function initializeHeroNavigation() {
    var wrappers = document.querySelectorAll(SELECTORS.wrapper);

    wrappers.forEach(function (wrapper) {
      setupHeroNavigation(wrapper);
    });
  }

  /*
   * Impulse page loaded event.
   */
  document.addEventListener('page:loaded', function () {
    initializeHeroNavigation();

    /*
     * Give Flickity a moment to finish initializing.
     */
    setTimeout(initializeHeroNavigation, 100);
    setTimeout(initializeHeroNavigation, 500);
  });

  /*
   * Standard DOM fallback.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeHeroNavigation();

      setTimeout(initializeHeroNavigation, 100);
      setTimeout(initializeHeroNavigation, 500);
    });
  } else {
    initializeHeroNavigation();

    setTimeout(initializeHeroNavigation, 100);
    setTimeout(initializeHeroNavigation, 500);
  }

  /*
   * Shopify Theme Editor support.
   *
   * This is important when you add/reload the slideshow
   * through the Theme Customizer.
   */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;

    if (!section) {
      return;
    }

    var wrappers = section.querySelectorAll(SELECTORS.wrapper);

    wrappers.forEach(function (wrapper) {
      setupHeroNavigation(wrapper);

      setTimeout(function () {
        setupHeroNavigation(wrapper);
      }, 100);

      setTimeout(function () {
        setupHeroNavigation(wrapper);
      }, 500);
    });
  });

})();